<template lang="pug">
    .coupon-holder
        a.card(
            href="#"
            :class="{ unlinked: data.deleted }"
            @click.prevent="showForm = true"
        )
            template(v-if="data.id.startsWith('new')")
                el-button.unlink-button(
                    plain
                    circle
                    size="mini"
                    type="danger"
                    icon="el-icon-fa-trash-alt fas"
                    @click.stop.prevent="$emit('delete', data)"
                )
            template(v-else)
                el-tooltip.item(
                    v-if="!data.deleted"
                    key="unlink-tooltip"
                    effect="dark"
                    :content="$t('Unlink coupon from {customer}', { customer: customerName})"
                    placement="top"
                )
                    el-button.unlink-button(
                        plain
                        circle
                        size="mini"
                        type="warning"
                        icon="el-icon-fa-unlink fas"
                        @click.stop.prevent="$emit('unlink', data)"
                    )
                el-tooltip.item(
                    v-else
                    key="link-tooltip"
                    effect="dark"
                    :content="$t('Link coupon to {customer}', { customer: customerName})"
                    placement="top"
                )
                    el-button.unlink-button(
                        plain
                        circle
                        size="mini"
                        type="success"
                        icon="el-icon-fa-link fas"
                        @click.stop.prevent="$emit('link', data)"
                    )

            h4.heading
                //- span.icon
                //-     i.el-icon-fa-percentage.fas(v-if="data.type === 'percentage'")
                //-     i.el-icon-fa-money-bill.fas(v-else)
                //- span(v-if="type === 'auto-apply'") {{ $t('Discount') }}
                //- span(v-else) {{ $t('Coupon') }}
                span {{ $t('Coupon') }}
            small.help(v-if="autoApply") {{ $t('will be applied automatically') }}

            //- pre {{ data }}
            .infos
                .name(v-if="data.name")
                    dt {{ $t('Name') }}
                    dd {{ data.name }}
                .code(v-if="!autoApply")
                    dt {{ $t('Code') }}
                    dd {{ data.code }}
                .percentage(v-if="data.type === 'percentage'")
                    dt {{ $t('Percentage') }}
                    dd {{ data.percentage }}%
                .price(v-else)
                    dt {{ $t('Fixed amount') }}
                    dd {{ data.amount | moneyFormat(currencyCode)  }}
                //- template(v-if="data.position")
                //-     dt {{ $t('Priority') }}
                //-     dd {{ data.position }}
                // hr
                .spacer
                template
                    dt {{ $t('Used by {customer}', { customer: customerName }) }}
                    dd
                        span(v-if="data.pivot && data.pivot.uses") {{ data.pivot.uses }}
                        span(v-else) 0
                        span(v-if="data.max_uses_per_customer") &nbsp/ {{ data.max_uses_per_customer }}
                        //- span(v-else) &nbsp/ ∞
                dt {{ $t('Total uses') }}
                dd
                    span {{ data.times_used || 0 }}
                    span(v-if="data.max_uses") &nbsp/ {{ data.max_uses }}
                    //- span(v-else) &nbsp/ ∞
                template(v-if="data.start_at")
                    dt {{ $t('Cannot be redeemed before') }}
                    dd {{ data.start_at | timestamp2date(dateTimeFormat) }}
                template(v-if="data.end_at")
                    dt {{ $t('Cannot be redeemed after') }}
                    dd {{ data.end_at | timestamp2date(dateTimeFormat) }}

        CouponForm(
            :data="data"
            :customer="customer"
            :visibility.sync="showForm"
            @submit="coupon => $emit('submit', coupon)"
        )
</template>

<i18n>
{
    "en": {
        "Unlink coupon from {customer}": "Unlink coupon from {customer}",
        "Link coupon to {customer}": "Link coupon to {customer}",
        "Used by {customer}": "Used by {customer}"
    },
    "de": {
        "Coupon": "Gutschein",
        "Discount": "Rabatt",
        "Priority": "Priorität",
        "Amount": "Betrag",
        "Fixed amount": "Fester Betrag",
        "Percentage": "Prozentsatz",
        "Code": "Code",
        "Name": "Bezeichnung",
        "Description": "Beschreibung",
        "Amount": "Betrag",
        "Net": "Netto",
        "Gross": "Brutto",
        "Max. uses": "Max. Anzahl der Verwendungen",
        "Max. uses per customer": "Verwendungen pro Kunde",
        "Cannot be redeemed before": "Nicht einlösbar vor",
        "Cannot be redeemed after": "Nicht einlösbar nach",
        "Unlink coupon from {customer}": "Verknüpfung von {customer} lösen",
        "Link coupon to {customer}": "Mit {customer} verknüpfen",
        "Used by {customer}": "Eingelöst von {customer}",
        "Total uses": "Eingelöst insgesamt",
        "Discard the following coupons/discounts": "Nachfolgende Gutscheine/Rabatte verwerfen",
        "will be applied automatically": "wird automatisch angewendet"
    }
}
</i18n>

<script>
import _ from 'lodash';
import { useSetupStore } from '@/stores'
import { moneyFormat, timestamp2date } from '@/filters';

import quillConfig from '@/quill/config'

import CouponForm from './CouponForm'

export default {
    name: 'Coupon',
    props: {
        data: {
            type: Object,
            required: true
        },
        customer: {
            type: Object,
            required: true
        },
        options: {
            type: Object,
            required: true,
        },
        customerName: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            showForm: false,
            quillConfig
        }
    },
    components: {
        CouponForm
    },
    filters: {
        moneyFormat,
        timestamp2date
    },
    computed: {
        // type() {
        //     let type = 'coupon'
        //     if (this.data.code === null || this.data.code === undefined) type = 'auto-apply'
        //     return type
        // },
        autoApply() {
            return this.data.code === null || this.data.code === undefined
        },
        dateTimeFormat() {
            const template = this.$t('yyyy-MM-dd')
            return `${template}, HH:mm`
        },
        currencyCode() {
            return _.get(this.customer, 'customerGroup.currency.iso4217')
                || _.get(this.activeCms, 'shop.defaultCustomerGroup.currency.iso4217')
        },
        setupStore() {
            return useSetupStore()
        },
        activeCms() {
            return this.setupStore.activeCms
        },
    },
}
</script>

<style lang="sass" scoped>
$border-radius: 4px
.coupon-holder
    display: inline-block
.card
    display: flex
    flex-direction: column
    background-color: lighten($color-skeleton, 1%)
    border-radius: $border-radius
    border: 1px solid $--border-color-light
    width: 100%
    padding: 1rem
    position: relative
    text-decoration: none
    color: initial
    transition: border-color .15s ease
    min-height: 100%
    +res(lg)
        // max-width: 420px
        max-width: 442px
    &.unlinked
        // background: rgba($--color-warning, .12)
        background-color: lighten($color-body, 5%)
        border: 1px solid lighten($--border-color-light, 5%)
        pointer-events: none
        .unlink-button
            opacity: 1
            pointer-events: auto
        .heading,
        .name,
        .infos
            opacity: 0.5

    &:not(.unlinked)
        &:hover,
        &:focus
            border-color: $--color-primary
            .unlink-button
                opacity: 1
    .icon
        margin-right: 4px
    .heading
        color: darken($color-grey-text, 10%)
        font-weight: 400
        margin: 0
    .infos
        margin-top: 1rem
        flex-grow: 1
        display: flex
        flex-direction: column
        hr
            border: none
        .spacer
            flex-grow: 1
            min-height: 1rem
    .unlink-button
        position: absolute
        right: 0.5rem
        top: 0.5rem
        z-index: 1
        opacity: 0
        transition: opacity .15s ease
    .help
        color: darken($color-grey-text, 10%)
</style>
